export const DEFAULT_TITLE = "NonoJs · Free Nonogram Platform";
export const SETTINGS_TITLE = "NonoJs · Settings";
export const CATALOG_TITLE = "Looking at catalog";
export const NOT_FOUND_TITLE = "404 Not Found";
export const LOGIN_TITLE = "Log in to NonoJs";

export function PLAYFIELD_TITLE(width: number, height: number) {
    return `Playing ${width}x${height} Nonogram`
};